import { t } from '@lingui/core/macro';

import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';

import BenchmarksByChannel from './BenchmarksByChannel';

const BenchmarksOverview = () => {
  return (
    <Page
      title={t`Web Traffic`}
      pageName={t`Benchmarks`}
      exampleAIQuestions={exampleAIQuestions('analytics')}
    >
      <PageFilterProvider>
        <div className="flex w-full flex-col gap-6">
          <div className="flex items-start justify-between">
            <PageDateRangeFilter />
            <PendoPlaceholder />
          </div>
          <BenchmarksByChannel />
        </div>
      </PageFilterProvider>
    </Page>
  );
};

export default BenchmarksOverview;
